
import { computed, defineComponent, ref, watch } from 'vue';
import { OioRow, OioCol, OioInputNumber, OioForm, OioFormItem, OioSpin } from '@kunlun/vue-ui-antd';
import { FormInstance, Rule } from 'ant-design-vue/lib/form';
import { onMounted } from 'vue';
import Decimal from 'decimal.js';

const paytypeMap = {
  CREDITPAY: '授信',
  REBATEPAY: '权益金',
  FUNDPAY: '现金'
};

export default defineComponent({
  name: 'CreditPay',
  components: {
    OioInputNumber,
    OioRow,
    OioCol,
    OioForm,
    OioFormItem,
    OioSpin
  },
  props: [
    'formData',
    'setFormInstance',
    'validation1',
    'formLoading',
    'changePayType',
    'changePayValue',
    'setAboveFlag'
  ],
  setup(props) {
    const formRef = ref<FormInstance>();

    const itemOptions = computed<{ label: string; value: string }[]>(() => {
      return (
        props.formData?.accountTypeList?.map((i) => ({ label: paytypeMap[i], value: i, disabled: i === 'FUNDPAY' })) ??
        []
      );
    });

    const payNumValidator = (item) => {
      return async (_rule: Rule, value: string) => {
        // if (value === null) {
        //   return Promise.reject('请输入支付金额');
        // }

        // 最多两位小数
        let reg = /^(\-)*(\d+)\.(\d\d).*$/;
        item.payAmount = String(item.payAmount || 0).replace(reg, '$1$2.$3');
        value = String(value || 0).replace(reg, '$1$2.$3');

        const currentValue = new Decimal(value);
        const { payMinUseBalance = 0, payMaxUseBalance = 0 } = item;
        const minValue = new Decimal(payMinUseBalance),
          maxValue = new Decimal(payMaxUseBalance);
        if (currentValue.lt(minValue)) {
          return Promise.reject('支付金额未满足订单支付配置的约束最低的支付金额');
        } else if (currentValue.gt(maxValue)) {
          return Promise.reject('支付金额超出订单支付配置的约束最高的支付金额');
        }
        return Promise.resolve();
      };
    };

    const totalAmount = computed(() => {
      const creditTotal =
        props.formData?.creditFundBooks?.reduce(
          (t, c) => new Decimal(t).plus(new Decimal(c.payAmount || '0')).toNumber(),
          0
        ) ?? 0;
      const rebateTotal =
        props.formData?.rebateFundBooks?.reduce(
          (t, c) => new Decimal(t).plus(new Decimal(c.payAmount || '0')).toNumber(),
          0
        ) ?? 0;
      const fundBooksTotal =
        props.formData?.fundBooks?.reduce(
          (t, c) => new Decimal(t).plus(new Decimal(c.payAmount || '0')).toNumber(),
          0
        ) ?? 0;

      return new Decimal(creditTotal).plus(new Decimal(rebateTotal)).plus(new Decimal(fundBooksTotal)).toNumber();
    });
    const isAbove = computed(() => Number(totalAmount.value.toFixed(2)) > Number(props.formData.actualAmount));

    watch(totalAmount, (val) => {
      props.setAboveFlag(Number(val.toFixed(2)) > Number(props.formData.actualAmount));
    });

    onMounted(() => {
      props.setFormInstance(formRef.value);
    });

    return {
      formRef,
      itemOptions,
      paytypeMap,
      payNumValidator,
      totalAmount,
      isAbove
    };
  }
});
